export interface GNIP {
    gameId: string
    networkId: string
    instanceId: string
    playerId: string
}

export function decodeGnip(value: string): GNIP {
    const [gameId, networkId, instanceId, playerId] = value.split('-')
    return { gameId, networkId, instanceId, playerId }
}

export function encodeGnip({ gameId, networkId, instanceId, playerId }: GNIP): string {
    return [gameId, networkId, instanceId, playerId].join('-')
}

export interface IShopMessageBus {
    post(message: any): void
}
